import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const CURRENT_PATH = 'current_path';
export const PREVIOUS_PATH = 'previous_path';

export const useStoragePageHistory = () => {
    const router = useRouter();

    useEffect(() => {
        const storage = window?.localStorage;

        if (!storage) {
            return;
        }
        const currentPath = storage.getItem(CURRENT_PATH);

        if (window.location.pathname === currentPath) {
            return;
        }

        if (currentPath) {
            storage.setItem(PREVIOUS_PATH, currentPath);
        }

        storage.setItem(CURRENT_PATH, window.location.pathname);
    }, [router.asPath]);
};
